/**
 * Sentry — frontend wiring
 * ------------------------
 * Zero-cost no-op until REACT_APP_SENTRY_DSN is set in .env.
 *
 * Why wrap instead of bare init(): this module is imported unconditionally by
 * src/index.js, so if Derwin forgets the DSN, the app still boots cleanly.
 *
 * Sample rates deliberately conservative:
 *   traces     10% — performance data; more than enough for <10K MAU
 *   replay      0% — not enabling session replay (privacy + cost)
 */
import * as Sentry from '@sentry/react';

const DSN = process.env.REACT_APP_SENTRY_DSN;

export function initSentry() {
  if (!DSN) return;
  Sentry.init({
    dsn: DSN,
    environment: process.env.REACT_APP_SENTRY_ENV || 'production',
    integrations: [
      // BrowserTracing for perf data — automatically instruments react-router v6
      Sentry.browserTracingIntegration(),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.2,  // capture replay on errors only
    ignoreErrors: [
      // Browser extension noise
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed',
      'Non-Error promise rejection captured',
    ],
  });
}

export { Sentry };
